import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "@/locales/en.json";
import es419 from "@/locales/es-419.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es-419", label: "Español" },
] as const;

export type SupportedLanguageCode = (typeof SUPPORTED_LANGUAGES)[number]["code"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      "es-419": { translation: es419 },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    interpolation: {
      // React already escapes values, so i18next doesn't need to.
      escapeValue: false,
    },
    detection: {
      // Order: explicit user choice (localStorage) > browser language > fallback.
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
    returnNull: false,
  });

export default i18n;
